export const Types = {
  GET_PERMISSIONS: "permissions/GET_PERMISSIONS",
  GET_FULL_COMUNICADOS: "permissions/GET_FULL_COMUNICADOS",
  GET_FULL_COMUNICADOS_SUCCESS: "permissions/GET_FULL_COMUNICADOS_SUCCESS",
  GET_PERMISSIONS_SUCCESS: "permissions/GET_PERMISSIONS_SUCCESS"
};

const INITIAL_STATE = {
  data: [],
  avatar: null,
  master: null,
  id: null,
  comunicados: [],
  pesquisador_module: null,
  pesquisador: null,
  super_user: null,
  see_general: null,
  name: null,
  company: null,
  notifications: [],
  chat_key: null,
  url_click_to_call: null,
  token_click_to_call: null,
  account_click_to_call: null,
  ramal: null
};

export default function permissions(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_PERMISSIONS:
      return { ...state };
    case Types.GET_FULL_COMUNICADOS:
      return { ...state };
    case Types.GET_FULL_COMUNICADOS_SUCCESS:
      return {
        ...state,
        comunicados: action.payload.comunicados
      };
    case Types.GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        data: action.payload.permissions,
        avatar: action.payload.avatar,
        master: action.payload.master,
        id: action.payload.id,
        comunicados: action.payload.comunicados,
        pesquisador_module: action.payload.pesquisador_module,
        pesquisador: action.payload.pesquisador,
        super_user: action.payload.super_user,
        see_general: action.payload.see_general,
        name: action.payload.name,
        company: action.payload.company,
        notifications: action.payload.notifications,
        chat_key: action.payload.chat_key,
        url_click_to_call: action.payload.url_click_to_call,
        token_click_to_call: action.payload.token_click_to_call,
        account_click_to_call: action.payload.account_click_to_call,
        ramal: action.payload.ramal
      };
    default:
      return state;
  }
}

export const Creators = {
  getPermissions: () => ({
    type: Types.GET_PERMISSIONS
  }),
  getFullComunicados: () => ({
    type: Types.GET_FULL_COMUNICADOS
  }),
  getFullComunicadosSuccess: comunicados => ({
    type: Types.GET_FULL_COMUNICADOS_SUCCESS,
    payload: { comunicados }
  }),
  getPermissionsSuccess: (
    permissions,
    avatar,
    master,
    id,
    comunicados,
    pesquisador_module,
    pesquisador,
    super_user,
    see_general,
    name,
    company,
    notifications,
    chat_key,
    url_click_to_call,
    token_click_to_call,
    account_click_to_call,
    ramal
  ) => ({
    type: Types.GET_PERMISSIONS_SUCCESS,
    payload: {
      permissions,
      avatar,
      master,
      id,
      comunicados,
      pesquisador_module,
      pesquisador,
      super_user,
      see_general,
      name,
      company,
      notifications,
      chat_key,
      url_click_to_call,
      token_click_to_call,
      account_click_to_call,
      ramal
    }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/permissions.js